import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { playgroundUrls, productionUrls } from './config';
import { CheggEnv } from '@chegg/utils';
export var getCiteThisForMeUrl = function getCiteThisForMeUrl(environment) {
  var _ref = environment === CheggEnv.PROD ? productionUrls() : playgroundUrls(),
    citethisformeUrl = _ref.citethisformeUrl;
  return citethisformeUrl;
};
export var siteMapper = function siteMapper(site) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 'easybib', 'eb'), 'bibme', 'bm'), 'citationmachine', 'cm'), 'chegg', 'cw'), 'citethisforme', 'ctfm')[site];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/selectors.js
// module id = 1247
// module chunks = 11